export const STATUS = {
  SUBMITTED: "Pending Approval",
  PENDING: "Pending Approval",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CREATED: "Pending Approval",
};
export const TIMESHEET_STATUSES = {
  SUBMITTED: "SUBMITTED",
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};
export const VALUE_TO_STATUS = {
  "Pending Approval": "SUBMITTED",
  Approved: "APPROVED",
  Rejected: "REJECTED",
};
export const PROJECT_ACTIVITY_TIME_VALUE_TO_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING: "PENDING",
  CREATED: "PENDING",
};
